<template>
<layout-content>
  <template #toolbar>
    <section class="toolbar-btn">
      <el-button
        type="orange"
        icon="el-icon-plus"
        size="small"
        @click="onOpenEditor()"
      >新建{{editName}}</el-button>
    </section>
  </template>

  <template #body>
    <data-wrapper>
      <el-table
        ref="table"
        :data="list"
        height="100%"
        border
        stripe
        highlight-current-row
        header-row-class-name="custom-table-header"
        class="custom-table no-inner-border"
        style="width: 100%"
        @selection-change="onSelectionChange"
        @row-click="onOpenEditor"
      >
        <el-table-column label="序号" width="50">
          <template slot-scope="{$index}">{{$index + 1}}</template>
        </el-table-column>

        <el-table-column prop="name" label="角色名称" width="200" />
        <el-table-column prop="description" label="角色描述" />

        <el-table-column label="操作" width="150" align="center">
          <template slot-scope="{row}">
            <div class="table-operator-wrapper">
            <span class="table-operator-btn delete-btn" @click.stop="onShowDeleteConfirmDialog(row)">
              <i class="el-icon-delete" aria-hidden="true"></i>
            </span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </data-wrapper>
  </template>

  <template #editor>
    <editor
      ref="editor"
      @save="getList"
      @close="onCancelHighlightTableRow"
    />
  </template>
</layout-content>
</template>

<script>
import LayoutContent from '../../../components/Layout/Content'
import BaseListEditor from '../../BaseListEditor'
import Editor from './Editor'
import DataWrapper from '../../../components/Data/DataWrapper'

export default {
  name: 'SystemSettingsRole',
  routeInfo: {
    label: '角色管理',
    icon: 'fa fa-user',
    curdInfo: {
      api: 'Role',
      id: 'id',
      name: 'name',
      editName: '角色'
    }
  },
  extends: BaseListEditor,
  components: {DataWrapper, Editor, LayoutContent},
  created () {
    this.getList()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/09System-Settings/03Role/index.vue